import React, { memo, Fragment, useEffect, useCallback } from "react";

import { useAxiomState } from "__AxiomComponents/AxiomHooks/AxiomHooks";
import AxiomSpinner from "__AxiomComponents/AxiomUI/AxiomSpinner/AxiomSpinner";

import HawkeyeV2Selection from "../HawkeyeV2Selection/HawkeyeV2Selection";

import "./HawkeyeV2FilterSelection.scss";

function HawkeyeV2FilterSelection(props) {
  const [state, dispatch] = useAxiomState(
    {
      selectedFilterValues: [],
    },
    props.appName,
    props.appID,
    "HawkeyeV2FilterSelection",
    props.componentID
  );

  const {
    filterValues,
    selectedFilter,
    onSelection,
    onCancel,
    isFetchingValues,
    renderSymbol,
    selectedValues,
  } = props;
  const { selectedFilterValues } = state;

  useEffect(() => {
    if (selectedValues) {
      dispatch({ selectedFilterValues: selectedValues });
    } else {
      dispatch((state) =>
        state.selectedFilterValues.length > 0 ? { selectedFilterValues: [] } : null
      );
    }
  }, [dispatch, selectedFilter, selectedValues]);

  const onFilterValueSelection = useCallback(
    (filterValue) => {
      dispatch((state) => {
        const selectedValues = [...state.selectedFilterValues];
        const searchIndex = selectedValues.map((i) => i.key).indexOf(filterValue.key);
        if (searchIndex > -1) {
          selectedValues.splice(searchIndex, 1);
          return { selectedFilterValues: selectedValues };
        } else {
          return { selectedFilterValues: [...selectedValues, filterValue] };
        }
      });
    },
    [dispatch]
  );

  const onSelectionCompletion = () => {
    onSelection(selectedFilterValues);
    dispatch({ selectedFilterValues: [] });
  };

  return (
    <div className={"hawkeye-filter-create-section hawkeye-filter-create-values"}>
      {isFetchingValues && (
        <div className="hawkeye-filter-subnav-loader">
          <AxiomSpinner spinnerWidth={24} />
        </div>
      )}
      {filterValues.length > 0 && (
        <Fragment>
          <h3 className="hawkeye-filter-subnav-title">Select filter values </h3>
          <HawkeyeV2Selection
            className="hawkeye-filter-subnav-values"
            isSearchable={true}
            options={filterValues}
            selectedOptions={selectedFilterValues}
            onSelection={onFilterValueSelection}
            appName={props.appName}
            appID={props.appID}
            componentID={props.componentID}
            renderSymbol={renderSymbol}
          />
          <div className="hawkeye-filter-subnav-footer">
            <button onClick={onSelectionCompletion} className="hawkeye-btn hawkeye-btn-primary">
              OK
            </button>
          </div>
        </Fragment>
      )}
    </div>
  );
}

export default memo(HawkeyeV2FilterSelection);
